const actionTypes = { SET_CONTENT: 'SET_CONTENT' };

module.exports = actionTypes;
